export default __webpack_public_path__ + "static/media/gallery-9-1.24d3cc9f.jpg";